import restaurantInstance from '../instance'

const updateTableTimerConfigs = (id, data) => {
	return restaurantInstance.put(`/tableTimerConfigs/${id}`, data)
}

export default updateTableTimerConfigs
